const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={20} fill="none">
    <path
      fill="#fff"
      d="M7 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM7 0a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Z"
    />
  </svg>
);
export default LocationIcon;
